import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react'
import { cn } from '@bem-react/classname'
import { Memo } from '@/hoc/Memo'

import './Container.scss'

const cnContainer = cn('Container')

export interface ContainerSchema
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: ReactNode
}

export const Container: FC<ContainerSchema> = Memo(
  ({ className, children }: ContainerSchema) => {
    return <div className={cnContainer(null, [className])}>{children}</div>
  },
)
